import { useState } from "react";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { RecallClientActionsDataInterface } from "../../../../../redux/interfaces/recall.interface";
import useRecallClientAwbAction from "../useRecallClientAwbAction";
import useRecallClientAwbPrintAction from "../useRecallClientAwbPrintAction";
import useRecallClientDocumentAction from "../useRecallClientDocumentAction";
import useRecallClientEmailAction from "../useRecallClientEmailAction";
import RecallClientAwbPrintModal from "../RecallClientAwbPrintModal";
import RecallClientReceiptsModal from "../RecallClientReceiptsModal";
import RecallClientSalesModal from "../RecallClientSalesModal";

function RecallClientsActionButton({
  crudData,
}: {
  crudData: RecallClientActionsDataInterface;
}) {
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [showReceiptsModal, setShowReceiptsModal] = useState(false);
  const documentAction = useRecallClientDocumentAction({ client: crudData });
  const awbAction = useRecallClientAwbAction({ client: crudData });
  const awbPrint = useRecallClientAwbPrintAction({ client: crudData });
  const emailAction = useRecallClientEmailAction({ client: crudData });
  const items: ActionMenuItem[] = [
    {
      id: "sales",
      label: "Vanzari",
      icon: "SUMMARIZE",
      tooltip:
        "Deschide vanzarile identificate pentru farmacie, cu facturile si cantitatile pe produs si lot.",
      onClick: () => setShowSalesModal(true),
    },
    documentAction,
    awbAction,
    awbPrint.action,
    {
      id: "received-quantities",
      label: "Cantitati primite",
      icon: "RECEIPTS",
      tooltip: crudData.notice?.receivedAt
        ? "Afiseaza cantitatile inregistrate ca primite de la farmacie, in cutii si fractii, pe produs si lot."
        : "Cantitatile primite pot fi consultate dupa confirmarea primirii documentului.",
      disabled: !crudData.notice?.receivedAt,
      onClick: () => setShowReceiptsModal(true),
    },
    { ...emailAction, dividerBefore: true },
  ];

  return (
    <>
      <ActionMenu
        items={items}
        title={crudData.pharmacyName}
        ariaLabel={`Actiuni pentru farmacia ${crudData.pharmacyName}`}
        minItemsForMenu={2}
      />
      {awbPrint.showModal && (
        <RecallClientAwbPrintModal
          client={crudData}
          handleClose={awbPrint.handleClose}
        />
      )}
      {showSalesModal && (
        <RecallClientSalesModal
          pharmacyName={crudData.pharmacyName}
          sales={crudData.sales}
          handleClose={() => setShowSalesModal(false)}
        />
      )}
      {showReceiptsModal && (
        <RecallClientReceiptsModal
          idCampaign={crudData.idCampaign}
          clientPlId={crudData.clientPlId}
          pharmacyName={crudData.pharmacyName}
          handleClose={() => setShowReceiptsModal(false)}
        />
      )}
    </>
  );
}

export default RecallClientsActionButton;
